import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'adminUser', ...(require('/app/src/models/adminUser.js').default) });
app.model({ namespace: 'appConfigs', ...(require('/app/src/models/appConfigs.js').default) });
app.model({ namespace: 'dealerDashboard', ...(require('/app/src/models/dealerDashboard.js').default) });
app.model({ namespace: 'entityIntegrations', ...(require('/app/src/models/entityIntegrations.js').default) });
app.model({ namespace: 'entityUsers', ...(require('/app/src/models/entityUsers.js').default) });
app.model({ namespace: 'global', ...(require('/app/src/models/global.js').default) });
app.model({ namespace: 'pricingStrategies', ...(require('/app/src/models/pricingStrategies.js').default) });
app.model({ namespace: 'setting', ...(require('/app/src/models/setting.js').default) });
app.model({ namespace: 'singleuser', ...(require('/app/src/models/singleuser.js').default) });
app.model({ namespace: 'twoFactor', ...(require('/app/src/models/twoFactor.js').default) });
app.model({ namespace: 'user', ...(require('/app/src/models/user.js').default) });
app.model({ namespace: 'vehicleForm', ...(require('/app/src/models/vehicleForm.js').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
